<template>
  <div>
    <!-- LOADING -->
    <loading v-if="loading"/>

    <!-- CONFIRMACIÓN DE ENVIO -->
    <div v-if="!loading && enviado">
      <h2 class="text-primary-dark seccion">Emitir proyecto de {{ proyecto.ramo.nombre }}</h2>
      <p class="text-center"><logo-cia :id="cotizacion.compania.id" class="border text-center text-md-left px-2" width="150"/></p>
      <p class="lead text-center">Se ha solicitado la emisión de su seguro de {{ proyecto.ramo.nombre }} con la compañía {{ cotizacion.compania.nombre }}.</p>
      <p class="text-center">En breve nuestros agentes formalizarán la solicitud.</p>
      <p class="text-center">Gracias Por confiar en nosotros.</p>
    </div>

    <!-- formulario de emision -->
    <div v-if="!loading && !enviado">
      <h2 class="text-primary-dark seccion">Emitir proyecto de {{ proyecto.ramo.nombre }}</h2>
      
      <h5 class="text-primary-dark text-uppercase mb-0">Datos del proyecto</h5>
      <div class="row">
        <div class="col-lg-4 col-md-6">
          <label class="label-ficha">Tomador</label>
          {{ proyecto.cliente.tomador }}
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="label-ficha">Ramo</label>
          {{ proyecto.ramo.nombre }}
        </div>
        <div class="col-lg-2 col-md-6">
          <label class="label-ficha">Referencia</label>
          {{ proyecto.id }}
        </div>
        <div class="col-lg-2 col-md-6">
          <label class="label-ficha">Fecha</label>
          {{ proyecto.fechaApertura|fecha }}
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
          <label class="label-ficha">Compañía</label>
          <div class="text-center text-md-left">
            {{ cotizacion.compania.nombre }}<br/>
            <logo-cia :id="cotizacion.compania.id" class="border text-center text-md-left px-2" width="150" height="67"/>
          </div>
        </div>
        <div class="col-md-6">
          <label class="label-ficha">Importe</label>
          <strong>{{ cotizacion.primaAnual|decimal }} €</strong>
        </div>
      </div>

      <h5 class="text-primary-dark text-uppercase mb-0 mt-3">Datos para la emisión</h5>
      <form @submit.prevent="emitir()">
        <div class="row">
          <div class="col-md-6 col-xl-3 form-group">
            <label class="label-form">NIF</label>
            <input type="text" v-model="nif" class="form-control"/>
          </div>
          <div class="col-md-6 col-xl-3 form-group">
            <label class="label-form">Efecto</label>
            <input-date v-model="efecto" class="form-control"/>
          </div>
          <div class="col-md-6 col-xl-3 form-group">
            <label class="label-form">Forma de pago</label>
            <select v-model="formaPago" class="form-control">
              <option v-for="forma in formasPago" :key="forma" :value="forma">{{forma}}</option>
            </select>
          </div>
          <div class="col-md-6 col-xl-3 form-group">
            <label class="label-form">IBAN</label>
            <input type="text" v-model="iban" class="form-control"/>
          </div>
          <div class="col-md-12 form-group">
            <label class="label-form">Comentarios</label>
            <textarea v-model="comentario" class="form-control"></textarea>
          </div>
          <div class="col-md-12 text-right"><input type="submit" value="Emitir proyecto" class="btn btn-primary"/></div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import util from '@/util'
import Loading from '@/components/widgets/Loading'
import LogoCia from '@/components/widgets/LogoCia'
import InputDate from '@/components/widgets/InputDate'
export default {
  data() {
    return {
      loading: true,
      enviado: false,
      proyecto: {},
      nif: null,
      iban: null,
      formaPago: 'Pago Único',
      formasPago: [
        'Pago Único',
        'Anual',
        'Mensual',
        'Bimensual',
        'Trimestral',
        'Cuatrimestral',
        'Semestral'
      ],
      comentario: null,
      efecto: new Date(),
    }
  },
  computed: {
    ...mapGetters({
      urlBase: 'urlBase',
      credentials: 'credentials'
    }),
    cotizacion() {
      for(let i = 0; i < this.proyecto.cotizacion.length; i++) {
        if (this.$route.params.cotizacion == this.proyecto.cotizacion[i].id) {
          return this.proyecto.cotizacion[i];
        }
      }
    }
  },
  mounted() {
    this.getCliente()
    this.getProyecto()
  },
  methods: {
    getProyecto() {
      let grupos = [
        'oportunidad.cotizacion',
        'oportunidad.ramo',
        'cotizacion.compania',
        'cotizacion.producto',
        'cotizacion.documentos'
      ]
      let params = {
        'grupos': grupos.join(',')
      }

      let url = this.urlBase + 'oportunidades/' + this.$route.params.proyecto + '?' + util.objToQuery(params)
      this.$http.get(url).then(
          (response) => {
            this.proyecto = response.body
            this.loading = false
            console.log(this.proyecto)
          },
          (error) => {
            this.loading = false
            if (error.status === 401) {
              this.$router.push({name:'Login'})
            }
          }
      );
    },
    getCliente() {
       // Obtener datos del cliente para rellenarlos en el form
      let grupos = [
          'cliente.domiciliaciones'
      ]
      let params = {
          'grupos': grupos.join(',')
      }
      let url = this.urlBase + 'clientes/'+ this.credentials.id + '?' + util.objToQuery(params);

      this.$http.get(url).then(
          (response) => {
            this.nif = response.body.nif;
            response.body.domiciliacionBancaria.forEach(function(cuenta) {
              if (cuenta.activa) {
                this.iban = cuenta.cuenta;
              }
            }, this);
          },
          (error) => {
          }
      );
    },
    emitir() {
      this.loading = true;
      let url = this.urlBase + 'incidenciasClientes';
      //Formatear solicitud para la incidencia
      var texto =
      'Emitir la cotización ' + this.cotizacion.id + ' de ' +
      this.cotizacion.compania.nombre + ' ' +
      this.cotizacion.producto.nombre + ' con prima de ' +
      this.cotizacion.primaAnual + '€ con los siguientes datos: \n' +
      'CIF: ' + this.nif + ' - ' +
      'Fecha efecto: ' + this.efecto.getDate() + "/" + (this.efecto.getMonth() + 1) + "/" + this.efecto.getFullYear() + ' - ' +
      'IBAN: ' + this.iban + ' - ' +
      'Forma pago: ' + this.formaPago + ' - ' +
      'Comentario: ' + this.comentario;

      let data = {
        objeto: this.proyecto.id,
        descripcion: texto,
        tipoObjeto: 160
      };
      let options = {
      };
      console.log(data)
      this.$http.post(url, data, options).then(
          (response) => {
            this.loading = false;
            this.enviado = true;
          },
          (error) => {
            this.loading = false
            this.enviado = false
            if (error.status === 401) {
              this.$router.push({name:'Login'})
            }
          }
      );
    }
  },
  components: {
    Loading,
    LogoCia,
    InputDate
  }
}
</script>

<style>

</style>
